import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

import './modal.general.css';
const width = {
  sm: '25',
  md: '45',
  lg: '75',
  '': '75',
};

function AppModalHeader({ children, classNames = '', ...props }) {
  if (children)
    return (
      <div className={`app-modal-header modal-header ${classNames}`} {...props}>
        {children}
      </div>
    );

  return null;
}

function AppModalBody({ children, classNames = '', ...props }) {
  if (children)
    return (
      <div className={`app-modal-content modal-body ${classNames}`} {...props}>
        {children}
      </div>
    );

  return null;
}

function AppModalFooter({ children, classNames = '', ...props }) {
  if (children)
    return (
      <div className={`app-modal-actions ${classNames}`} {...props}>
        {children}
      </div>
    );

  return null;
}

function AppModal({ open, closeModal, size = 'lg', popUpProps = {}, children, modalProps = {} }) {
  return (
    <Popup
      open={open}
      closeOnDocumentClick
      onClose={closeModal}
      // contentStyle={{ width: '90%' }}
      className={`app-l-modal width-spec-${width[size]}`}
      {...popUpProps}
    >
      {(close) => {
        const { classNames = '', ...mProps } = modalProps;
        return (
          <div className={`app-modal ${classNames}`} {...mProps}>
            {/* <button type="button" className="app-modal-close" onClick={close}>
              &times;
            </button> */}

            <div className="modal-content">{children}</div>
          </div>
        );
      }}
    </Popup>
  );
}

AppModal.defaultProps = {
  open: false,
  closeModal: () => {},
};

export { Popup as AppPopup, AppModal, AppModalHeader, AppModalBody, AppModalFooter };
